import { ReactElement } from 'react';
import { useGetGeofenceQuery } from '@casops/store/apis/geofencesApi';
import useLoadModelData from '@casops/components/layout/model-form/useLoadModelData';
import { useTranslation } from 'react-i18next';
import { DrawerPanel } from '@dmc/ui';
import { useLoadGeofenceDataDependencies } from '../manage-geofence/useLoadGeofenceDataDependencies';
import GeofenceFormReadonly from './components/form/GeofenceFormReadonly';

// Load all of the API data dependencies here before rendering the form.
export function ReadGeofence(): ReactElement {
  const { t } = useTranslation();

  const { isLoaded: isItemLoaded, item } = useLoadModelData({
    useModelQueryHook: useGetGeofenceQuery,
  });

  const { isLoaded, renderKey } = useLoadGeofenceDataDependencies({ isItemLoaded, item });

  return (
    <DrawerPanel isLoaded={isLoaded} header={t('GeofenceProperties')}>
      <GeofenceFormReadonly key={renderKey} item={item} />
    </DrawerPanel>
  );
}

export default ReadGeofence;
